import {
  closestCenter,
  DndContext,
  DragOverlay,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core"
import { arrayMove, SortableContext } from "@dnd-kit/sortable"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Collapse, Row } from "reactstrap"
import {
  cloneSubCalendar,
  reorderSubCalendars,
  updateSubCalendarStatus,
} from "store/actions"
import SortableSubCalendarItem from "./SortableSubCalendarItem"
import SubCalendarItem from "./SubCalendarItem"

const SubCalendarList = ({
  handleBookSubCalendar,
  handleEditSubCalendar,
  handleDeleteSubCalendar,
  cloneSubCalendar,
  reorderSubCalendars,
  vendorId,
  calendarId,
  allSubCalendars,
  isOpen,
  reorderIsTriggered,
  reordered,
  updateSubCalendarStatus,
}) => {
  const [subCalendarsState, setSubCalendarsState] = useState([])
  const [activeId, setActiveId] = useState(null)
  const [orderIsAsc, setOrderIsAsc] = useState(true)

  useEffect(() => {
    if (reorderIsTriggered) {
      const items = [...subCalendarsState]
      items.sort((a, b) => {
        const nameA = a.name.toUpperCase()
        const nameB = b.name.toUpperCase()
        if (nameA < nameB) {
          return orderIsAsc ? -1 : 1
        }
        if (nameA > nameB) {
          return orderIsAsc ? 1 : -1
        }

        return 0
      })
      setSubCalendarsState(items)
      setOrderIsAsc(!orderIsAsc)
      reorderSubCalendars({
        vendor_id: vendorId,
        booking_types: items?.map((item, index) => ({
          id: item?.id,
          order: index + 1,
        })),
      })
      reordered()
    }
  }, [reorderIsTriggered])

  useEffect(() => {
    setSubCalendarsState(
      allSubCalendars?.filter(
        subCalendar => subCalendar?.calendar_id === calendarId
      )
    )
  }, [calendarId])

  useEffect(() => {
    let arr = [
      ...allSubCalendars?.filter(
        subCalendar => subCalendar?.calendar_id === calendarId
      ),
    ]
    setSubCalendarsState(arr.sort((a, b) => a.order - b.order))
  }, [allSubCalendars])

  const subCalendarActions = [
    {
      name: "Book",
      onClick: item => {
        handleBookSubCalendar(item)
      },
      icon: "bx bx-calendar-plus",
      isAvailable: true,
    },
    {
      name: "Edit",
      onClick: item => {
        handleEditSubCalendar(item)
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Clone",
      onClick: item => {
        {
          cloneSubCalendar({ id: item?.id })
        }
      },
      icon: "bx bx-duplicate",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: item => {
        handleDeleteSubCalendar(item)
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor))

  const handleDragStart = event => {
    setActiveId(event?.active?.id)
  }

  const handleDragEnd = event => {
    reorderSubCalendars({
      vendor_id: vendorId,
      booking_types: subCalendarsState?.map((item, index) => ({
        id: item?.id,
        order: index + 1,
      })),
    })
    setActiveId(null)
  }

  const handleDragOver = event => {
    const { active, over } = event
    if (active.id !== over.id) {
      setSubCalendarsState(items => {
        const oldIndex = items.findIndex(i => i.id === active.id)
        const newIndex = items.findIndex(i => i.id === over.id)

        return arrayMove(items, oldIndex, newIndex)
      })
    }
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
    >
      <SortableContext
        id={"subCalendars"}
        items={subCalendarsState?.map(calendar => calendar?.id)}
        strategy={() => {}}
      >
        <Collapse isOpen={isOpen} className="mt-3">
          <Row>
            {subCalendarsState?.map(subCalendar => (
              <SortableSubCalendarItem
                id={subCalendar?.id}
                key={subCalendar?.id}
                subCalendar={subCalendar}
                subCalendarActions={subCalendarActions}
                updateSubCalendarStatus={updateSubCalendarStatus}
              />
            ))}
          </Row>
        </Collapse>
      </SortableContext>
      <DragOverlay>
        {activeId ? (
          <SubCalendarItem
            isDragging
            subCalendar={subCalendarsState?.find(
              calendar => calendar?.id === activeId
            )}
          />
        ) : null}
      </DragOverlay>
    </DndContext>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  allSubCalendars: state.BookingsFeature.allSubCalendars,
})

const mapDispatchToProps = dispatch => ({
  cloneSubCalendar: values => dispatch(cloneSubCalendar(values)),
  updateSubCalendarStatus: values => dispatch(updateSubCalendarStatus(values)),
  reorderSubCalendars: values => dispatch(reorderSubCalendars(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SubCalendarList)
